<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">资产入库</h2>
    </div>
    <div class="form-content">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="110px" class="form">
          <asset-form ref="create" :userData="userData" :formByFather="form"></asset-form>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button :loading="formLoading" @click="createAsset()" class="form-btn" type="success">{{formBtnText}}
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </div>
  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  // import Create1 from '../form/create1'
  import AssetForm from './components/assetForm'
  export default {
    components: {
      AssetForm,
    },
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        // 组织架构
        organizationListData: [],
        // 是否可以切换公司
        noSelectOrganization: true,

        form: {
          depId: '',
          number: '',
          name: '',
          amount: 1,
          attributeId: '',
          bxTime: '',
          ccTime: '',
          classifyId: '',
          manufacturer: '',
          price: '',
          purchaseTime: '',
          remark: '',
          spec: '',
          storageTime: '',
          supplierId: '',
          assetDeptId: '',
          usePlace: '',
          userId: '',
          ver: '',
          certificateNum: '',
          panType: false,

          // 残值、折旧年限
          cz: '',
          zjnx: '',

          // 0715
          rzTime: '',
          zrUserId: '',
          cwUserId: '',

          // 0920
          zjhm: '',
          mj: '',
          attachments: '',

          status: 0,
        },

        // loading状态
        formLoading: false,
        formBtnText: '确认提交'
      }
    },
    mounted() {
      this.organizationListData = this.organization[0].childDepts
      this.form.depId = this.userData.secDepIds.split(",")[0] / 1
      if (this.userData.secDepIds.split(",")[0] == "7") {
        this.noSelectOrganization = false
      }
    },
    methods: {
      createAsset() {
        this.form = this.$refs.create.getFromData()
        if (!this.form.classifyId) {
          this.$message.error("资产分类是必选项，请选择资产分类后提交")
          return
        }
        if (!this.form.name || !this.form.attributeId || !this.form.price || !this.form.purchaseTime || !this.form.cz ||
          !this.form.zjnx) {
          this.$message.error("带*号为必填项，请检查后提交")
          return
        }
        this.panType = this.panType == true ? '1' : ''

        ajax.post('/asset/add', this.form, (res) => {
          this.$message.success("添加资产成功")
          this.$router.push("/Asset/List")
        })
      },
    },
    watch: {

    },
    // beforeRouteLeave(to, from, next) {
    //   next()
    // },
  };
</script>


// WEBPACK FOOTER //
// src/page/asset/create.vue